// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { authTokenVerify, refreshToken } from "./components/redux/api/admin/authApi";

// // const PublicRoute = ({ children }) => {
// //   const [isAuthenticated, setIsAuthenticated] = useState(false);

// //   useEffect(() => {
// //     const checkAuth = async () => {
// //       const resf = await refreshToken();
// //       const isValid = await authTokenVerify();
// //       // console.log("isValid", isValid);
// //       setIsAuthenticated(isValid.verify);
// //     };
// //     checkAuth();
// //   }, []);

// //   if (!isAuthenticated) {
// //     return (
// //       <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
// //         <div className="spinner-border text-primary" role="status">
// //           <span className="visually-hidden">Loading...</span>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return isAuthenticated ? <Navigate to="/home" replace /> : children;
// // };

// const PublicRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading

//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         await refreshToken();
//         const isValid = await authTokenVerify();
//         setIsAuthenticated(isValid.verify);
//       } catch (err) {
//         setIsAuthenticated(false); // failed verification
//       }
//     };
//     checkAuth();
//   }, []);

//   if (isAuthenticated === null) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return isAuthenticated ? <Navigate to="/home" replace /> : children;
// };

// export default PublicRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';
// import { isAdminAuthenticated } from '../../utils/adminAuth';
import { isAdminAuthenticated } from './components/pages/AdminPannel/utils/adminAuth';

const AdminPublicRoute = ({ children }) => {
  // Direct check without loading state
  const isAuthenticated = isAdminAuthenticated();

  // If already authenticated, redirect to admin dashboard
  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default AdminPublicRoute;